import OrderedList from '@tiptap/extension-ordered-list'

const CustomOrderedList = OrderedList.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            type: {
                default: undefined,
                parseHTML: element => element.getAttribute('type'),
                renderHTML: (attributes) => {
                    if (!attributes.type) {
                        return {}
                    }

                    return {
                        style: `list-style-type: ${attributes.type}`,
                    }
                },
            },
        }
    }
})

export default CustomOrderedList